/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentDraftsControllerVersionQueryResponse, DocumentDraftsControllerVersionPathParams, DocumentDraftsControllerVersionQueryParams, DocumentDraftsControllerVersion400, DocumentDraftsControllerVersion401, DocumentDraftsControllerVersion403, DocumentDraftsControllerVersion404 } from "../../models/documentDraftsController/DocumentDraftsControllerVersion";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { documentDraftsControllerVersion } from "../../clients/document-draftsService/documentDraftsControllerVersion";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const documentDraftsControllerVersionQueryKey = (threadId: DocumentDraftsControllerVersionPathParams["threadId"], version: DocumentDraftsControllerVersionPathParams["version"], params: DocumentDraftsControllerVersionQueryParams) => [{
  url: '/api/v1/document-drafts/:threadId/versions/:version',
  params: {
    threadId: threadId,
    version: version
  }
}, ...(params ? [params] : [])] as const;
export type DocumentDraftsControllerVersionQueryKey = ReturnType<typeof documentDraftsControllerVersionQueryKey>;
export function documentDraftsControllerVersionQueryOptions(threadId: DocumentDraftsControllerVersionPathParams["threadId"], version: DocumentDraftsControllerVersionPathParams["version"], params: DocumentDraftsControllerVersionQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = documentDraftsControllerVersionQueryKey(threadId, version, params);
  return queryOptions<DocumentDraftsControllerVersionQueryResponse, ResponseErrorConfig<DocumentDraftsControllerVersion400 | DocumentDraftsControllerVersion401 | DocumentDraftsControllerVersion403 | DocumentDraftsControllerVersion404>, DocumentDraftsControllerVersionQueryResponse, typeof queryKey>({
    enabled: !!(threadId && version && params),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return documentDraftsControllerVersion(threadId, version, params, config);
    }
  });
}

/**
 * {@link /api/v1/document-drafts/:threadId/versions/:version}
 */
export function useDocumentDraftsControllerVersion<TData = DocumentDraftsControllerVersionQueryResponse, TQueryData = DocumentDraftsControllerVersionQueryResponse, TQueryKey extends QueryKey = DocumentDraftsControllerVersionQueryKey>(threadId: DocumentDraftsControllerVersionPathParams["threadId"], version: DocumentDraftsControllerVersionPathParams["version"], params: DocumentDraftsControllerVersionQueryParams, options: {
  query?: Partial<QueryObserverOptions<DocumentDraftsControllerVersionQueryResponse, ResponseErrorConfig<DocumentDraftsControllerVersion400 | DocumentDraftsControllerVersion401 | DocumentDraftsControllerVersion403 | DocumentDraftsControllerVersion404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? documentDraftsControllerVersionQueryKey(threadId, version, params);
  const query = useQuery({
    ...documentDraftsControllerVersionQueryOptions(threadId, version, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<DocumentDraftsControllerVersion400 | DocumentDraftsControllerVersion401 | DocumentDraftsControllerVersion403 | DocumentDraftsControllerVersion404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}